import React, { Component } from "react";
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { LOGIN_TYPE_ADMIN,GetSettingURL,UpdateSettingURL,CLIENT_LIST, api_sources} from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import $ from "jquery";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import moment from 'moment';
import Header from "./include/Header";
import { Link } from "react-router-dom";

import Select2 from 'react-select2-wrapper';
import { Alert, DateRangePicker } from 'rsuite';
//import { json } from "stream/consumers";

class SettingEdit extends Component {
  state = {
    common_setting_db_id:'',
    rc_prime_bulk_upload_source_order:[],
    rc_prime_bulk_upload_source_order_default:api_sources.RCExcel,
    rc_prime_bulk_upload_owndb_cache_days:0,

    mobile_rc_bulk_upload_source_order:[],
    mobile_rc_bulk_upload_source_order_default:api_sources.MobileRCExcel,
    mobile_rc_bulk_upload_owndb_cache_days:0,
    mobile_rc_bulk_upload_limit:0,

    challan_bulk_upload_source_order:[],
    challan_bulk_upload_source_order_default:api_sources.ChallanExcel,
    challan_bulk_upload_owndb_cache_days:0,

    rc_prime_reverse_api_source_order:[],
    rc_prime_reverse_api_source_order_default:api_sources.RCPrimeReverse,
    rc_prime_reverse_owndb_cache_days_for_Api:0,

    rc_prime_api_source_order:[],
    rc_prime_api_source_order_default:api_sources.RCPrime,
    rc_prime_owndb_cache_days_for_Api:0,

    free_rc_api_hit_source_order:[],
    free_rc_api_hit_source_order_default:api_sources.RCFree,

    challan_api_hit_source_order:[],
    challan_api_hit_source_order_default:api_sources.Challan,

    rcPrimeChallan_prime_source_order:[],
    rcPrimeChallan_prime_source_order_default:api_sources.RCPrime,

    rcPrimeChallan_challan_source_order:[],
    rcPrimeChallan_challan_source_order_default:api_sources.Challan,

    fcm_challan_api_hit_source_order:[],
    fcm_challan_api_hit_source_order_default:api_sources.FCMChallan,

    rc_challan_owndb_cache_days_for_Api:0,
    fcm_challan_cron_cache_days:0,
    fcm_challan_cron_interval_days:0,

    rcPrimeChallan_prime_owndb_cache_days:0,
    rcPrimeChallan_challan_owndb_cache_days:0,

    panFetch_owndb_cache_days:0,
    aadhaarFetch_owndb_cache_days:0,

    fcm_insurance_cron_interval_days:0,
    fcm_insurance_cron_expire_notify_days:0,

    fcm_pucc_cron_interval_days:0,
    fcm_pucc_cron_expire_notify_days:0,

    token_expire_days:0,

    unlink_file_days:0,

    api_source_call_timeout:0,
    api_source_call_retry_timeout:0,
    api_source_call_timeout_advanceForgery:0,
    api_source_call_timeout_aadhaarFetch:0,

    rate_limit_mmv_hit:0,
    rate_limit_mmv_duration:0,
    rate_limit_rcprime_hit:0,
    rate_limit_rcprime_duration:0,
    rate_limit_default_hit:0,
    rate_limit_default_duration:0,


    vehicle_service_history_sentemail_enable:false,
    vehicle_service_history_sentmail_bbusers:[],

    monthly_client_wise_rcprime_api_hit_cc_email:[],
    monthly_client_wise_rcprime_api_hit_cc_email_list_seleced_value:[],
    update_monthly_client_wise_rcprime_api_hit_cc_email_list_string:'',

    zeta_auth_token:'',

    vehicle_service_history_sentemail_list: [],
    vehicle_service_history_sentemail_list_seleced_value:[],
    update_vehicle_service_history_sentemail_list_string:'',

    //add on
    bbuser_auto_renewal_exprie_token_cc_email: [],
    bbuser_auto_renewal_exprie_token_cc_email_list_seleced_value:[],
    update_auto_renewal_exprie_token_cc_email_list_string:'',

    bbuser_auto_renewal_exprie_token_days_interval:0,
    bbuser_auto_renewal_token_notify_expire_days:0,
    bbuser_business_unit_options:[],
    bbuser_business_unit_options_sel:[],
     
    aadhaarFetch_mail_notify_email: [],
    aadhaarFetch_mail_notify_email_list_selected_value:[],
    update_auto_aadhaarFetch_mail_notify_email_list_string:'',
    //add on 
    //clientList:[],

    //add on
    dbOptimizStartDate:null,
    dbOptimizEndDate:null,
    dbOptimizApiType:[],
    dbOptimizSelectedSource:[],
    dbOptimizSelectedReason:[]
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.get_Data_Of_Setting();
    //this.loadClientListDetail();
    //this.handleChangeVehicleServiceHistorySentEmailBbusers=this.handleChangeVehicleServiceHistorySentEmailBbusers.bind(this);
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {}
    $(".defaultOrder").on("select2:select", function (evt) {
      var element = evt.params.data.element;
      //console.log('element',element);
      var $element = $(element);
      $element.detach();
      $(this).append($element);
      $(this).trigger("change");
    });
    
  }

  arrayOrderManage = (defaultArray, valueArray) => {
    valueArray.forEach(ele => {
      if (valueArray.indexOf(ele) > -1) {
        defaultArray.splice(defaultArray.indexOf(ele),1);
        defaultArray.push(ele);
      }
    });
    return defaultArray;
  }

  get_Data_Of_Setting = () => {
    Apihelpers.getdataresponse(GetSettingURL).then(res => {
      var data=res.data.data;
      console.log('data',data);

      let rcPrimeExcelDefault = this.arrayOrderManage(api_sources.RCExcel, data.rc_prime_bulk_upload_source_order);
      let challanExcelDefault = this.arrayOrderManage(api_sources.ChallanExcel, data.challan_bulk_upload_source_order);
      let mobileRCExcelDefault = this.arrayOrderManage(api_sources.MobileRCExcel, data.mobile_rc_bulk_upload_source_order);
      //console.log('rcPrimeExcelDefault',rcPrimeExcelDefault);
      let rcPrimeReverseDefault = this.arrayOrderManage(api_sources.RCPrimeReverse, data.rc_prime_reverse_api_source_order);
      let rcPrimeDefault = this.arrayOrderManage(api_sources.RCPrime, data.rc_prime_api_source_order);
      let freeRcDefault = this.arrayOrderManage(api_sources.RCFree, data.free_rc_api_hit_source_order);
      let challanDefault = this.arrayOrderManage(api_sources.Challan, data.challan_api_hit_source_order);
      let fcmChallanDefault = this.arrayOrderManage(api_sources.FCMChallan, data.fcm_challan_api_hit_source_order);
      let rcPrimeChallan_primeDefault = this.arrayOrderManage(api_sources.RCPrime,data.rcPrimeChallan_prime_source_order);
      let rcPrimeChallan_challanDefault = this.arrayOrderManage(api_sources.Challan,data.rcPrimeChallan_challan_source_order)
      
      this.setState({
        common_setting_db_id:data._id,

        rc_prime_bulk_upload_source_order:data.rc_prime_bulk_upload_source_order,
        rc_prime_bulk_upload_source_order_default:rcPrimeExcelDefault,
        rc_prime_bulk_upload_owndb_cache_days:data.rc_prime_bulk_upload_owndb_cache_days,

        mobile_rc_bulk_upload_source_order:data.mobile_rc_bulk_upload_source_order,
        mobile_rc_bulk_upload_source_order_default:mobileRCExcelDefault,
        mobile_rc_bulk_upload_owndb_cache_days:data.mobile_rc_bulk_upload_owndb_cache_days,
        mobile_rc_bulk_upload_limit:data.mobile_rc_bulk_upload_limit,

        challan_bulk_upload_source_order:data.challan_bulk_upload_source_order,
        challan_bulk_upload_source_order_default:challanExcelDefault,
        challan_bulk_upload_owndb_cache_days:data.challan_bulk_upload_owndb_cache_days,

        rc_prime_reverse_api_source_order:data.rc_prime_reverse_api_source_order,
        rc_prime_reverse_api_source_order_default:rcPrimeReverseDefault,
        rc_prime_reverse_owndb_cache_days_for_Api:data.rc_prime_reverse_owndb_cache_days_for_Api,

        rc_prime_owndb_cache_days_for_Api:data.rc_prime_owndb_cache_days_for_Api,
        rc_prime_api_source_order:data.rc_prime_api_source_order,
        rc_prime_api_source_order_default:rcPrimeDefault,

        free_rc_api_hit_source_order:data.free_rc_api_hit_source_order,
        free_rc_api_hit_source_order_default:freeRcDefault,

        challan_api_hit_source_order:data.challan_api_hit_source_order,
        challan_api_hit_source_order_default:challanDefault,

        rcPrimeChallan_prime_source_order:data.rcPrimeChallan_prime_source_order,
        rcPrimeChallan_prime_source_order_default:rcPrimeChallan_primeDefault,

        rcPrimeChallan_challan_source_order:data.rcPrimeChallan_challan_source_order,
        rcPrimeChallan_challan_source_order_default:rcPrimeChallan_challanDefault,

        fcm_challan_api_hit_source_order:data.fcm_challan_api_hit_source_order,
        fcm_challan_api_hit_source_order_default:fcmChallanDefault,

        rc_challan_owndb_cache_days_for_Api:data.rc_challan_owndb_cache_days_for_Api,
        fcm_challan_cron_cache_days:data.fcm_challan_cron_cache_days,
        fcm_challan_cron_interval_days:data.fcm_challan_cron_interval_days,

        rcPrimeChallan_prime_owndb_cache_days:data.rcPrimeChallan_prime_owndb_cache_days,
        rcPrimeChallan_challan_owndb_cache_days:data.rcPrimeChallan_challan_owndb_cache_days,

        panFetch_owndb_cache_days:data.panFetch_owndb_cache_days,
        aadhaarFetch_owndb_cache_days:data.aadhaarFetch_owndb_cache_days,

        fcm_insurance_cron_interval_days:data.fcm_insurance_cron_interval_days,
        fcm_insurance_cron_expire_notify_days:data.fcm_insurance_cron_expire_notify_days,

        fcm_pucc_cron_interval_days:data.fcm_pucc_cron_interval_days,
        fcm_pucc_cron_expire_notify_days:data.fcm_pucc_cron_expire_notify_days,

        token_expire_days:data.token_expire_days,

        unlink_file_days:data.unlink_file_days,

        api_source_call_timeout:data.api_source_call_timeout,
        api_source_call_retry_timeout:data.api_source_call_retry_timeout,
        api_source_call_timeout_advanceForgery:data.api_source_call_timeout_advanceForgery,
        api_source_call_timeout_aadhaarFetch:data.api_source_call_timeout_aadhaarFetch,
        
        vehicle_service_history_sentemail_enable:data.vehicle_service_history_sentemail_enable,
        vehicle_service_history_sentmail_bbusers:data.vehicle_service_history_sentmail_bbusers,

        rate_limit_mmv_hit:data.rate_limit_mmv_hit,
        rate_limit_mmv_duration:data.rate_limit_mmv_duration,
        rate_limit_rcprime_hit:data.rate_limit_rcprime_hit,
        rate_limit_rcprime_duration:data.rate_limit_rcprime_duration,
        rate_limit_default_hit:data.rate_limit_default_hit,
        rate_limit_default_duration:data.rate_limit_default_duration,
       
        vehicle_service_history_sentemail_list:data.vehicle_service_history_sentemail_list.split(","),
        vehicle_service_history_sentemail_list_seleced_value:data.vehicle_service_history_sentemail_list.split(","),
        
        bbuser_auto_renewal_exprie_token_cc_email:data.bbuser_auto_renewal_exprie_token_cc_email.split(","),
        bbuser_auto_renewal_exprie_token_cc_email_list_seleced_value:data.bbuser_auto_renewal_exprie_token_cc_email.split(","),

        aadhaarFetch_mail_notify_email:data.aadhaarFetch_mail_notify_email?.split(","),
        aadhaarFetch_mail_notify_email_list_selected_value:data.aadhaarFetch_mail_notify_email?.split(","),

        monthly_client_wise_rcprime_api_hit_cc_email:data.monthly_client_wise_rcprime_api_hit_cc_email.split(","),
        monthly_client_wise_rcprime_api_hit_cc_email_list_seleced_value:data.monthly_client_wise_rcprime_api_hit_cc_email.split(","),
        
        bbuser_auto_renewal_exprie_token_days_interval:data.bbuser_auto_renewal_exprie_token_days_interval,
        bbuser_auto_renewal_token_notify_expire_days:data.bbuser_auto_renewal_token_notify_expire_days,
        bbuser_business_unit_options: data.bbuser_business_unit_options || [],
        bbuser_business_unit_options_sel: data.bbuser_business_unit_options || [],

        zeta_auth_token:data.zeta_auth_token,

        dbOptimizStartDate: data.dbOptimizStartDate,
        dbOptimizEndDate: data.dbOptimizEndDate,
        dbOptimizApiType: data.dbOptimizApiTypes,
        dbOptimizSelectedSource: data.dbOptimizSelectedSource,
        dbOptimizSelectedReason: data.dbOptimizSelectedReason,
      });
    });
  }
  // loadClientListDetail() {
  //   var clientListForInternal=[];
  //   Apihelpers.getdataresponse(CLIENT_LIST).then(res => {
  //     if (res.data.status === true) {
  //       var client_list=res.data.data[0]["clientist"];
  //       var result=client_list.map((values,index)=>{
  //          clientListForInternal[values.bbuserInfo[0]._id]= values.bbuserInfo[0].business_name;
  //         let client_display_name=values.bbuserInfo[0].business_name+" ("+values.bbuserInfo[0]._id+")";
  //         return {key:index,id:values.bbuserInfo[0]._id,text:client_display_name}
  //       });
  //       this.setState({
  //         clientList: result,
  //       });
  //       console.log('result state.clientList',result);
  //     } else {
  //     }
  //     console.log(clientListForInternal);
  //   });
  // }
  On_vehicle_service_history_enable=(e)=>
  {
    e.preventDefault();
    console.log(e.target);
    this.setState({
      vehicle_service_history_sentemail_enable: e.target.checked,
    });
  }
  update_data_into_DB = (event)=> {
    // var bbuser = $("#bbuser").val();
    // console.log(bbuser);
    if(this.state.rc_prime_bulk_upload_source_order.length <=0)
    {
      Alert.error("Source Order Of RCPrime Bulk Upload Can Not Be Empty.");
    }
    else if(this.state.challan_bulk_upload_source_order.length <=0)
    {
      Alert.error("Source Order Of Challan Bulk Upload Can Not Be Empty.");
    }
    else if(this.state.mobile_rc_bulk_upload_source_order.length <= 0)
    {
      Alert.error("Source order of Mobile RC Can Not Be Empty.")
    }
    else if(this.state.mobile_rc_bulk_upload_owndb_cache_days.length == 0 || parseInt(this.state.mobile_rc_bulk_upload_owndb_cache_days) < 0)
    {
      Alert.error("Owndb Cache Days Of Mobile RC Bulk Upload Can Not Be Empty & Should be Greater Than or equal 0.");
    }
    else if(this.state.rc_prime_reverse_api_source_order.length <=0)
    {
      Alert.error("Rc Prime Reverse Order Can Not Be Empty.")
    }
    else if(this.state.rc_prime_bulk_upload_owndb_cache_days.length ==0 || parseInt(this.state.rc_prime_bulk_upload_owndb_cache_days) < 0)
    {
      Alert.error("Owndb Cache Days Of Bulk Upload Can Not Be Empty & Should be Greater Than or equal 0.");
    }
    else if(this.state.mobile_rc_bulk_upload_limit.length ==0 || parseInt(this.state.mobile_rc_bulk_upload_limit) < 0)
    {
      Alert.error("Bulk Upload Limit Can Not Be Empty & Should be Greater Than or equal 0.");
    }
    else if(this.state.challan_bulk_upload_owndb_cache_days.length == 0 || parseInt(this.state.challan_bulk_upload_owndb_cache_days) < 0)
    {
      Alert.error("Owndb Cache Days Of Challan Bulk Upload Can Not Be Empty & Should be Greater Than or equal 0.");
    }
    else if(this.state.rc_prime_reverse_owndb_cache_days_for_Api.length ==0 || parseInt(this.state.rc_prime_reverse_owndb_cache_days_for_Api)< 0)
    {
      Alert.error("Owndb Cache Days Of Rc Prime Reverse Can Not Be Empty & Should be Greater Than or equal 0.")
    }
    else if(this.state.rc_prime_owndb_cache_days_for_Api.length ==0 || parseInt(this.state.rc_prime_owndb_cache_days_for_Api)< 0)
    {
      Alert.error("Owndb Cache Days Of RC-Prime API Can Not Be Empty & Should be Greater Than or equal 0.");
    }
    else if(this.state.rc_prime_api_source_order.length <=0)
    {
      Alert.error("Source Order Of RC-Prime API Can Not Be Empty.");
    }
    else if(this.state.free_rc_api_hit_source_order.length <=0)
    {
      Alert.error("Source Order Of RC API Can Not Be Empty.")
    }
    else if(this.state.challan_api_hit_source_order.length <=0)
    {
      Alert.error("Source Order of Challan API Can Not Be Empty.")
    }
    else if(this.state.rcPrimeChallan_prime_source_order.length <= 0)
    {
      Alert.error("RCPrimeChallan Prime Source Order Can Not Be Empty.")
    }
    else if(this.state.rcPrimeChallan_challan_source_order.length <= 0)
    {
      Alert.error("RCPrimeChallan Challan Source Order Can Not Be Empty.")
    }
    else if(this.state.fcm_challan_api_hit_source_order.length <=0)
    {
      Alert.error("FCM Source Order of Challan API Can Not Be Empty.")
    }
    else if(this.state.token_expire_days <=0)
    {
      Alert.error("Token Expire Days Of Dashboard Info Should Be Greater Than 0.");
    }
    else if(this.state.unlink_file_days <=0)
    {
      Alert.error("Unlink File Expire Days Should Be Greater Than 0.");
    }
    else if(this.state.api_source_call_timeout <= 0)
    {
      Alert.error("Api Source TimeOut Should Be Greater Than 0.");
    }
    else if(this.state.api_source_call_retry_timeout <= 0)
    {
      Alert.error("Api Source Retry TimeOut Should Be Greater Than 0.");
    }
    else if(this.state.api_source_call_timeout_advanceForgery <= 0)
    {
      Alert.error("AdvanceForgery Api Source Timeout Should Be Greater Than 0.")
    }
    else if(this.state.api_source_call_timeout_aadhaarFetch <= 0)
    {
      Alert.error("Aadhaar Fetch Api Source Timeout Should Be Greater Than 0.")
    }
    // else if(this.state.vehicle_service_history_sentemail_enable == true && bbuser.length <=0)
    // {
    //   Alert.error("Please Select Vehicle Service History Sent Email Bbusers.");
    // }
    else if(this.state.vehicle_service_history_sentemail_list_seleced_value.length <=0)
    {
      Alert.error("Please Select Email Id For sent Email Of Vehicle service.");
    }

    else if(this.state.rate_limit_mmv_hit<=0)
    {
      Alert.error("Rate Limit MMV Hit Should Be Greater Than 0.");
    }
    else if(this.state.rate_limit_mmv_duration<=0)
    {
      Alert.error("Rate Limit MMV Duration Should Be Greater Than 0.");
    }
    else if(this.state.rate_limit_rcprime_hit<=0)
    {
      Alert.error("Rate Limit RC Prime Hit Should Be Greater Than 0.");
    }
    else if(this.state.rate_limit_rcprime_duration<=0)
    {
      Alert.error("Rate Limit  RC Prime Duration Should Be Greater Than 0.");
    }
    else if(this.state.rate_limit_default_hit<=0)
    {
      Alert.error("Rate Limit Default Hit Should Be Greater Than 0.");
    }
    else if(this.state.rate_limit_default_duration<=0)
    {
      Alert.error("Rate Limit Default Duration Should Be Greater Than 0.");
    }

    else if(this.state.bbuser_auto_renewal_token_notify_expire_days ==0 || parseInt(this.state.bbuser_auto_renewal_token_notify_expire_days) < parseInt(this.state.bbuser_auto_renewal_exprie_token_days_interval))
    {
      Alert.error("Bbuser Auto Renewal Token Notify Greater Than Bbuser Auto Renewal Exprie Token Days Interval.");
    }
    else if(this.state.panFetch_owndb_cache_days == 0 || parseInt(this.state.panFetch_owndb_cache_days)< 0)
    {
      Alert.error("Pan Fetch Cache Days Should be Greater Than or equal 0")  
    }
    else if(this.state.aadhaarFetch_owndb_cache_days == 0 || parseInt(this.state.aadhaarFetch_owndb_cache_days)< 0)
    {
      Alert.error("Aadhaar Fetch Cache Days Should be Greater Than or equal 0")     
    }
    else{
      $("#infoPopUp1").show();
    }
  }
  updateCommonSetting(){
    $(".customPopup").hide();
    //var bbuser = $("#bbuser").val();
    var data=
      {
      "_id":this.state.common_setting_db_id,
      "rc_prime_bulk_upload_owndb_cache_days":parseInt(this.state.rc_prime_bulk_upload_owndb_cache_days),
      "mobile_rc_bulk_upload_limit":parseInt(this.state.mobile_rc_bulk_upload_limit),
      "rc_prime_bulk_upload_source_order":this.state.rc_prime_bulk_upload_source_order,
      "challan_bulk_upload_owndb_cache_days":parseInt(this.state.challan_bulk_upload_owndb_cache_days),
      "challan_bulk_upload_source_order":this.state.challan_bulk_upload_source_order,
      "mobile_rc_bulk_upload_source_order":this.state.mobile_rc_bulk_upload_source_order,
      "mobile_rc_bulk_upload_owndb_cache_days":parseInt(this.state.mobile_rc_bulk_upload_owndb_cache_days),
      "rc_prime_owndb_cache_days_for_Api":parseInt(this.state.rc_prime_owndb_cache_days_for_Api),
      "rc_prime_reverse_api_source_order":this.state.rc_prime_reverse_api_source_order,
      "rc_prime_reverse_owndb_cache_days_for_Api":parseInt(this.state.rc_prime_reverse_owndb_cache_days_for_Api),
      "rc_prime_api_source_order":this.state.rc_prime_api_source_order,
      "rc_challan_owndb_cache_days_for_Api":parseInt(this.state.rc_challan_owndb_cache_days_for_Api),
      "rcPrimeChallan_prime_owndb_cache_days":parseInt(this.state.rcPrimeChallan_prime_owndb_cache_days),
      "rcPrimeChallan_challan_owndb_cache_days":parseInt(this.state.rcPrimeChallan_challan_owndb_cache_days),
      "panFetch_owndb_cache_days":parseInt(this.state.panFetch_owndb_cache_days),
      "aadhaarFetch_owndb_cache_days":parseInt(this.state.aadhaarFetch_owndb_cache_days),
      "fcm_challan_cron_cache_days":parseInt(this.state.fcm_challan_cron_cache_days),
      "fcm_challan_cron_interval_days":parseInt(this.state.fcm_challan_cron_interval_days),
      "fcm_insurance_cron_interval_days":parseInt(this.state.fcm_insurance_cron_interval_days),
      "fcm_insurance_cron_expire_notify_days":parseInt(this.state.fcm_insurance_cron_expire_notify_days),
      "fcm_pucc_cron_interval_days":parseInt(this.state.fcm_pucc_cron_interval_days),
      "fcm_pucc_cron_expire_notify_days":parseInt(this.state.fcm_pucc_cron_expire_notify_days),
      "token_expire_days":parseInt(this.state.token_expire_days),
      "api_source_call_timeout":parseInt(this.state.api_source_call_timeout),
      "api_source_call_retry_timeout":parseInt(this.state.api_source_call_retry_timeout),
      "api_source_call_timeout_advanceForgery":parseInt(this.state.api_source_call_timeout_advanceForgery),
      "api_source_call_timeout_aadhaarFetch":parseInt(this.state.api_source_call_timeout_aadhaarFetch),
      "vehicle_service_history_sentemail_enable":this.state.vehicle_service_history_sentemail_enable,
      //"vehicle_service_history_sentmail_bbusers":bbuser,
      "vehicle_service_history_sentemail_list":this.state.update_vehicle_service_history_sentemail_list_string,
      "bbuser_auto_renewal_exprie_token_days_interval":this.state.bbuser_auto_renewal_exprie_token_days_interval,
       "bbuser_auto_renewal_exprie_token_cc_email":this.state.update_auto_renewal_exprie_token_cc_email_list_string,
       "monthly_client_wise_rcprime_api_hit_cc_email":this.state.update_monthly_client_wise_rcprime_api_hit_cc_email_list_string,
       "free_rc_api_hit_source_order":this.state.free_rc_api_hit_source_order,
       "challan_api_hit_source_order":this.state.challan_api_hit_source_order,
       "fcm_challan_api_hit_source_order":this.state.fcm_challan_api_hit_source_order,
       "rcPrimeChallan_prime_source_order":this.state.rcPrimeChallan_prime_source_order,
       "rcPrimeChallan_challan_source_order":this.state.rcPrimeChallan_challan_source_order,
       "bbuser_auto_renewal_token_notify_expire_days":this.state.bbuser_auto_renewal_token_notify_expire_days,
       "unlink_file_days":parseInt(this.state.unlink_file_days),
       "zeta_auth_token":this.state.zeta_auth_token,

       "aadhaarFetch_mail_notify_email":this.state.update_auto_aadhaarFetch_mail_notify_email_list_string,

        "rate_limit_mmv_hit":parseInt(this.state.rate_limit_mmv_hit),
        "rate_limit_mmv_duration":parseInt(this.state.rate_limit_mmv_duration),
        "rate_limit_rcprime_hit":parseInt(this.state.rate_limit_rcprime_hit),
        "rate_limit_rcprime_duration":parseInt(this.state.rate_limit_rcprime_duration),
        "rate_limit_default_hit":parseInt(this.state.rate_limit_default_hit),
        "rate_limit_default_duration":parseInt(this.state.rate_limit_default_duration),

       "dbOptimizStartDate":this.state.dbOptimizStartDate,
       "dbOptimizEndDate":this.state.dbOptimizEndDate,
       "dbOptimizApiTypes":this.state.dbOptimizApiType,
       "dbOptimizSelectedSource":this.state.dbOptimizSelectedSource,
       "dbOptimizSelectedReason":this.state.dbOptimizSelectedReason,
        "bbuser_business_unit_options":this.state.bbuser_business_unit_options_sel
    }
    console.log('update data',data);
    Apihelpers.postdataresponse(UpdateSettingURL,data).then((res)=>{
      if(res.data.status) {
        Alert.success(res.data.message);
        //redirect to other page
        window.location.href = window.location.origin+'/admin/setting/';
      } else{
        Alert.error(res.data.message);
      }
    });
  }
  handleChangeBulkOrderChange(event) {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({rc_prime_bulk_upload_source_order: selected});
    console.log(this.state.rc_prime_bulk_upload_source_order);
  }
  handleChangeChallanBulkOrderChange(event) {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({challan_bulk_upload_source_order: selected});
    console.log(this.state.challan_bulk_upload_source_order);
  }
  handleChangeMobileRCBulkOrderChange(event) {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({mobile_rc_bulk_upload_source_order: selected});
    
  }
  handleChangeRCPrimeReverseAPIOrderChange(event) {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({rc_prime_reverse_api_source_order: selected});
    console.log(this.state.rc_prime_reverse_api_source_order);
  }
  handleChangeRCPrimeAPIOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({rc_prime_api_source_order: selected});
    console.log(this.state.rc_prime_api_source_order);
  }
  handleChangeRCAPIOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({free_rc_api_hit_source_order: selected});
    console.log(this.state.free_rc_api_hit_source_order);
  }
  handleChangeChallanAPIOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({challan_api_hit_source_order: selected});
    console.log(this.state.challan_api_hit_source_order);
  }
  handleChangeRCPrimeChallanAPIPrimeOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({rcPrimeChallan_prime_source_order: selected});
  }
  handleChangeRCPrimeChallanAPIChallanOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({rcPrimeChallan_challan_source_order: selected});
  }
  handleChangeFCMChallanAPIOrderChange(event)
  {
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState({fcm_challan_api_hit_source_order: selected});
    console.log(this.state.fcm_challan_api_hit_source_order);
  }
  handleChangeVehicleServiceHistorySentEmail=(event)=>{
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState(
      {
        vehicle_service_history_sentemail_list_seleced_value: selected,
        update_vehicle_service_history_sentemail_list_string:selected.join(",")
      });
  }
  handleChangeBbuserAutoRenewalExprieTokenCCEmail=(event)=>{
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState(
      {
        bbuser_auto_renewal_exprie_token_cc_email_list_seleced_value: selected,
        update_auto_renewal_exprie_token_cc_email_list_string:selected.join(",")
      });
  }

  handleChangeAadhaarFetchNotifyEmail=(event)=>{
    const selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      selected.push(selectedOption.item(i).value)
    }
    this.setState(
      {
        aadhaarFetch_mail_notify_email_list_selected_value: selected,
        update_auto_aadhaarFetch_mail_notify_email_list_string:selected.join(",")
      });
  }

  handleChangeVehicleServiceHistorySentEmailBbusers=(event)=>{
    const selected=[]
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      console.log(selectedOption.item(i));
      selected.push(selectedOption.item(i).value)
    }
    this.setState({vehicle_service_history_sentmail_bbusers: selected});
  }
  handleChangeRCPrimePerMonthCronSentEmailBbusers=(event)=>{
    const selected=[]
    let selectedOption=(event.target.selectedOptions);
    for (let i = 0; i < selectedOption.length; i++){
      console.log(selectedOption.item(i));
      selected.push(selectedOption.item(i).value)
    }
    this.setState({
      monthly_client_wise_rcprime_api_hit_cc_email_list_seleced_value:selected,
      update_monthly_client_wise_rcprime_api_hit_cc_email_list_string:selected.join(","),});
  }
  cancel = () => {
    $(".customPopup").hide();
  }
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      return (
        <React.Fragment>
          <div className="wrapper settingPage">
            <Header />
            <div className="container">
              <div className="whiteBox">
                <div className="titleRow">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="title">Edit Settings</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={"/admin/setting/"}><i className="fa fa-arrow-left"></i> Settings View</Link>
                        </div>
                    </div>
                </div>
                <div className="form">
                    <h4 className="subhading">RCExcel Service</h4>
                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-group">
                          <label className="control-title">
                            RCExcel bulk upload source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RCExcel bulk upload source order
                              </div>
                            </div>
                          </label>
                          {/* {this.state.rc_prime_bulk_upload_source_order} */}
                          <Select2 multiple data={this.state.rc_prime_bulk_upload_source_order_default} className="form-control defaultOrder" value={this.state.rc_prime_bulk_upload_source_order} options={{placeholder: 'search source',tags: false } } onChange={this.handleChangeBulkOrderChange.bind(this)} />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="form-group">
                          <label className="control-title">RCExcel bulk upload own database cache days</label>
                          <div className="toolTip">
                            <i className="infoIcon"></i>
                            <div className="toolTipText">
                            RCExcel bulk upload own database cache days
                            </div>
                          </div>
                          <input type="number" name="rc_prime_bulk_upload_owndb_cache_days" className="form-control" value={this.state.rc_prime_bulk_upload_owndb_cache_days} onChange={(e) => this.setState({rc_prime_bulk_upload_owndb_cache_days:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Mobile RC Excel Service</h4>
                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-group">
                          <label className="control-title">
                            Mobile RC Excel bulk upload source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Mobile RC Excel bulk upload source order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.mobile_rc_bulk_upload_source_order_default} className="form-control defaultOrder" value={this.state.mobile_rc_bulk_upload_source_order} options={{placeholder: 'search source',tags: false } } onChange={this.handleChangeMobileRCBulkOrderChange.bind(this)} />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="form-group">
                          <label className="control-title">Mobile RC Excel bulk upload own database cache days</label>
                          <div className="toolTip">
                            <i className="infoIcon"></i>
                            <div className="toolTipText">
                            Mobile RC Excel bulk upload own database cache days
                            </div>
                          </div>
                          <input type="number" name="mobile_rc_bulk_upload_owndb_cache_days" className="form-control" value={this.state.mobile_rc_bulk_upload_owndb_cache_days} onChange={(e) => this.setState({mobile_rc_bulk_upload_owndb_cache_days:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="form-group">
                          <label className="control-title">Mobile RC Excel bulk upload Limit</label>
                          <div className="toolTip">
                            <i className="infoIcon"></i>
                            <div className="toolTipText">
                            Mobile RC Excel bulk upload Limit
                            </div>
                          </div>
                          <input type="number" name="mobile_rc_bulk_upload_limit" className="form-control" value={this.state.mobile_rc_bulk_upload_limit} onChange={(e) => this.setState({mobile_rc_bulk_upload_limit:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Challan Excel Service</h4>
                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-group">
                          <label className="control-title">
                            Challan Excel bulk upload source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Challan Excel bulk upload source order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.challan_bulk_upload_source_order_default} className="form-control defaultOrder" value={this.state.challan_bulk_upload_source_order} options={{placeholder: 'search source',tags: false } } onChange={this.handleChangeChallanBulkOrderChange.bind(this)} />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="form-group">
                          <label className="control-title">Challan Excel bulk upload own database cache days</label>
                          <div className="toolTip">
                            <i className="infoIcon"></i>
                            <div className="toolTipText">
                            Challan Excel bulk upload own database cache days
                            </div>
                          </div>
                          <input type="number" name="challan_bulk_upload_owndb_cache_days" className="form-control" value={this.state.challan_bulk_upload_owndb_cache_days} onChange={(e) => this.setState({challan_bulk_upload_owndb_cache_days:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">RCPrime Service</h4>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">
                            RC Prime API source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RC Prime API source order
                              </div>
                            </div>
                          </label>
                          {/* rc_prime_api_source_order */}
                          <Select2 multiple data={this.state.rc_prime_api_source_order_default} value={this.state.rc_prime_api_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeRCPrimeAPIOrderChange.bind(this)} />
                        </div>

                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">RC Prime  Own Database cache days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                RC Prime  Own Database cache days
                              </div>
                            </div>
                          <input type="number" name="rc_prime_owndb_cache_days_for_Api" className="form-control" value={this.state.rc_prime_owndb_cache_days_for_Api}  onChange={(e) => this.setState({rc_prime_owndb_cache_days_for_Api:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-title">Monthly Client-Wise RC-Prime & Challan Api Hits CC Email</label>
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                  Monthly Client-Wise RC-Prime & Challan Api Hits CC Email
                                  </div>
                                </div>
                                <Select2 multiple data={this.state.monthly_client_wise_rcprime_api_hit_cc_email} value={this.state.monthly_client_wise_rcprime_api_hit_cc_email_list_seleced_value} className="form-control defaultOrder" options={{placeholder: 'search Email Id', tags: true } }  onChange={this.handleChangeRCPrimePerMonthCronSentEmailBbusers.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">RCPrime Reverse Service</h4>
                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-group">
                          <label className="control-title">
                             RCPrime Reverse source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RCPrime Reverse source order
                              </div>
                            </div>
                          </label>
                          {/* rc_prime_reverse_api_source_order */}
                          <Select2 multiple data={this.state.rc_prime_reverse_api_source_order_default} className="form-control defaultOrder" value={this.state.rc_prime_reverse_api_source_order} options={{placeholder: 'search source',tags: false } } onChange={this.handleChangeRCPrimeReverseAPIOrderChange.bind(this)} />
                        </div>
                      </div>
                      <div className="col-md-4">
                      <div className="form-group">
                          <label className="control-title">RCPrime Reverse Own Database Cache Days</label>
                          <div className="toolTip">
                            <i className="infoIcon"></i>
                            <div className="toolTipText">
                            RCPrime Reverse Own Database Cache Days
                            </div>
                          </div>
                          <input type="number" name="rc_prime_reverse_owndb_cache_days_for_Api" className="form-control" value={this.state.rc_prime_reverse_owndb_cache_days_for_Api} onChange={(e) => this.setState({rc_prime_reverse_owndb_cache_days_for_Api:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">RC Service</h4>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">
                            RC API source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RC API source order
                              </div>
                            </div>
                          </label>
                          {/* rc_api_source_order */}
                          <Select2 multiple data={this.state.free_rc_api_hit_source_order_default} value={this.state.free_rc_api_hit_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeRCAPIOrderChange.bind(this)} />
                        </div>

                      </div>
                    </div>
                    <h4 className="subhading">Vehicle Challan Service</h4>
                    <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">
                            Challan API source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Challan API source order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.challan_api_hit_source_order_default} value={this.state.challan_api_hit_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeChallanAPIOrderChange.bind(this)} />
                        </div>

                      </div>
                    <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">Vehicle Challan Own Database cache days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                Vehicle Challan  Own Database cache days
                              </div>
                            </div>
                          <input type="number" name="rc_challan_owndb_cache_days_for_Api" className="form-control" value={this.state.rc_challan_owndb_cache_days_for_Api}  onChange={(e) => this.setState({rc_challan_owndb_cache_days_for_Api:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">FCM Challan Cron Database Cache Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM Challan Cron Database Cache Days
                              </div>
                            </div>
                          <input type="number" name="fcm_challan_cron_cache_days" className="form-control" value={this.state.fcm_challan_cron_cache_days}  onChange={(e) => this.setState({fcm_challan_cron_cache_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">FCM Challan Cron User Interval Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM Challan Cron User Interval Days
                              </div>
                            </div>
                          <input type="number" name="fcm_challan_cron_interval_days" className="form-control" value={this.state.fcm_challan_cron_interval_days}  onChange={(e) => this.setState({fcm_challan_cron_interval_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">
                            FCM Challan API source order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM Challan API source order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.fcm_challan_api_hit_source_order_default} value={this.state.fcm_challan_api_hit_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeFCMChallanAPIOrderChange.bind(this)} />
                        </div>

                      </div>
                    </div>
                    <h4 className="subhading">Vehicle Combo Service</h4>
                    <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">
                            Combo Prime Api Source Order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Combo Prime Api Source Order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.rcPrimeChallan_prime_source_order_default} value={this.state.rcPrimeChallan_prime_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeRCPrimeChallanAPIPrimeOrderChange.bind(this)} />
                        </div>
                      </div>
                    <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">Combo Prime Api Own Database Cache Days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Combo Prime Api Own Database Cache Days
                              </div>
                            </div>
                          <input type="number" name="rcPrimeChallan_prime_owndb_cache_days" className="form-control" value={this.state.rcPrimeChallan_prime_owndb_cache_days}  onChange={(e) => this.setState({rcPrimeChallan_prime_owndb_cache_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">
                            Combo Challan Api Source Order
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Combo Challan Api Source Order
                              </div>
                            </div>
                          </label>
                          <Select2 multiple data={this.state.rcPrimeChallan_challan_source_order_default} value={this.state.rcPrimeChallan_challan_source_order} className="form-control defaultOrder" options={{placeholder: 'search source',tags: false }} onChange={this.handleChangeRCPrimeChallanAPIChallanOrderChange.bind(this)} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">Combo Challan Api Own Database Cache Days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Combo Challan Api Own Database Cache Days
                              </div>
                            </div>
                          <input type="number" name="rcPrimeChallan_challan_owndb_cache_days" className="form-control" value={this.state.rcPrimeChallan_challan_owndb_cache_days}  onChange={(e) => this.setState({rcPrimeChallan_challan_owndb_cache_days:e.target.value})}/>
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Vehicle Insurance Service</h4>
                    <div className="row"> 
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">FCM Insurance Cron User Interval Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM Insurance Cron User Interval Days
                              </div>
                            </div>
                          <input type="number" name="fcm_insurance_cron_interval_days" className="form-control" value={this.state.fcm_insurance_cron_interval_days}  onChange={(e) => this.setState({fcm_insurance_cron_interval_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">FCM Insurance Cron User Expire Reminder Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM Insurance Cron User Expire Reminder Days
                              </div>
                            </div>
                          <input type="number" name="fcm_insurance_cron_expire_notify_days" className="form-control" value={this.state.fcm_insurance_cron_expire_notify_days}  onChange={(e) => this.setState({fcm_insurance_cron_expire_notify_days:e.target.value})}/>
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Vehicle PUCC Service</h4>
                    <div className="row"> 
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">FCM PUCC Cron User Interval Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM PUCC Cron User Interval Days
                              </div>
                            </div>
                          <input type="number" name="fcm_pucc_cron_interval_days" className="form-control" value={this.state.fcm_pucc_cron_interval_days}  onChange={(e) => this.setState({fcm_pucc_cron_interval_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">FCM PUCC Cron User Expire Reminder Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              FCM PUCC Cron User Expire Reminder Days
                              </div>
                            </div>
                          <input type="number" name="fcm_pucc_cron_expire_notify_days" className="form-control" value={this.state.fcm_pucc_cron_expire_notify_days}  onChange={(e) => this.setState({fcm_pucc_cron_expire_notify_days:e.target.value})}/>
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Documents Verfication Service</h4>
                    <div className="row"> 
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Pan Fetch Own DB Cache Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Pan Fetch Own DB Cache Days
                              </div>
                            </div>
                          <input type="number" name="panFetch_owndb_cache_days" className="form-control" value={this.state.panFetch_owndb_cache_days}  onChange={(e) => this.setState({panFetch_owndb_cache_days:e.target.value})}/>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Aadhaar Fetch Own DB Cache Days:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Aadhaar Fetch Own DB Cache Days
                              </div>
                            </div>
                          <input type="number" name="aadhaarFetch_owndb_cache_days" className="form-control" value={this.state.aadhaarFetch_owndb_cache_days}  onChange={(e) => this.setState({aadhaarFetch_owndb_cache_days:e.target.value})}/>
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">BBUser Auto Renewal Token</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-title">Bbuser Auto Renewal Exprie Token CC Email</label>
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                    Bbuser Auto Renewal Exprie Token CC Email
                                  </div>
                                </div>
                                <Select2 multiple data={this.state.bbuser_auto_renewal_exprie_token_cc_email} value={this.state.bbuser_auto_renewal_exprie_token_cc_email_list_seleced_value} className="form-control defaultOrder" options={{placeholder: 'search Email Id', tags: true } }  onChange={this.handleChangeBbuserAutoRenewalExprieTokenCCEmail.bind(this)}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="control-title">Bbuser Business unit options</label>
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                Bbuser Business unit options
                              </div>
                            </div>
                            <Select2 multiple data={this.state.bbuser_business_unit_options}  className="form-control defaultOrder" options={{placeholder: 'add business unit', tags: true } } value={this.state.bbuser_business_unit_options_sel} onChange={(e)=>{
                              let ops = e.target.selectedOptions;
                              let selOpts = [];
                              for(let i = 0; i < ops.length; i++) {
                                selOpts.push(ops.item(i).value);
                              }
                              //console.log('selOpts',selOpts)
                              this.setState({
                                bbuser_business_unit_options_sel:selOpts
                              })
                            }}  />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                          <label className="control-title">Bbuser Auto Renewal Exprie Token Days Interval</label>
                          <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                  Bbuser Auto Renewal Exprie Token Days Interval
                                  </div>
                          </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.bbuser_auto_renewal_exprie_token_days_interval} onChange={(e) => this.setState({bbuser_auto_renewal_exprie_token_days_interval:e.target.value})} />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                          <label className="control-title">Bbuser Auto Renewal Token Notify Expire Days</label>
                          <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                  Bbuser Auto Renewal Token Notify Expire Days
                                  </div>
                          </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.bbuser_auto_renewal_token_notify_expire_days} onChange={(e) => this.setState({bbuser_auto_renewal_token_notify_expire_days:e.target.value})} />
                          </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-title">Aadhaar Fetch Mail Notify Email</label>
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                    Aadhaar Fetch Mail Notify Email
                                  </div>
                                </div>
                                <Select2 multiple data={this.state.aadhaarFetch_mail_notify_email} value={this.state.aadhaarFetch_mail_notify_email_list_selected_value} className="form-control defaultOrder" options={{placeholder: 'search Email Id', tags: true } }  onChange={this.handleChangeAadhaarFetchNotifyEmail.bind(this)}/>
                            </div>
                        </div>
                        
                    </div>
                    <h4 className="subhading">Vehicle Service History</h4>
                    <div className="row">
                        <div className="col-md-3">
                        <div className="form-group">
                          <label className="control-title">Vehicle service history sent email</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Vehicle service history sent email
                              </div>
                            </div>
                          <div className="formSwithc">
                              <label className="switch">
                                  <input name="vehicle_service_history_sentemail_enable" type="checkbox" onChange={(e) => this.setState({vehicle_service_history_sentemail_enable:e.target.checked})} checked={this.state.vehicle_service_history_sentemail_enable} />
                                  <span className="slider round"></span>
                              </label>
                          </div>
                        </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label className="control-title">Vehicle service history sent email bbusers</label>
                            <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                  Vehicle service history sent email bbusers
                                  </div>
                            </div>
                            <Select2 multiple data={this.state.clientList} value={this.state.vehicle_service_history_sentmail_bbusers} className="form-control defaultOrder" options={{placeholder: 'search Bbusers',tags:true } } id="bbuser" />
                          </div>
                        </div> */}
                        <div className="col-md-5">
                            <div className="form-group">
                                <label className="control-title">Vehicle service history & RC-Prime sent To email list</label>
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                  Vehicle service history sent To email list
                                </div>
                              </div>
                                <Select2 multiple data={this.state.vehicle_service_history_sentemail_list} value={this.state.vehicle_service_history_sentemail_list_seleced_value} className="form-control defaultOrder" options={{placeholder: 'search Email Id', tags: true } }  onChange={this.handleChangeVehicleServiceHistorySentEmail.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">API Source Setting</h4>
                    <div className="row">
                     <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">API Source TimeOut</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              API Source TimeOut
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.api_source_call_timeout} onChange={(e) => this.setState({api_source_call_timeout:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">API Source Retry TimeOut</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              API Source Retry TimeOut
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.api_source_call_retry_timeout} onChange={(e) => this.setState({api_source_call_retry_timeout:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">API Source TimeOut For AdvanceForgery</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              API Source TimeOut For AdvanceForgery
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.api_source_call_timeout_advanceForgery} onChange={(e) => this.setState({api_source_call_timeout_advanceForgery:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">API Source TimeOut For AadhaarFetch</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              API Source TimeOut For AadhaarFetch
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.api_source_call_timeout_aadhaarFetch} onChange={(e) => this.setState({api_source_call_timeout_aadhaarFetch:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Dashboard Setting</h4>
                    <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Token expire days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                Token expire days
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.token_expire_days} onChange={(e) => this.setState({token_expire_days:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Unlink file days</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Unlink file days
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.unlink_file_days} onChange={(e) => this.setState({unlink_file_days:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Rate Limit Setting</h4>
                    <div className="row">
                     <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">MMV API Per Hit:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              MMV API Per Hit:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_mmv_hit} onChange={(e) => this.setState({rate_limit_mmv_hit:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">MMV API Per Second:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              MMV API Per Second:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_mmv_duration} onChange={(e) => this.setState({rate_limit_mmv_duration:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">RC Prime API Per Hit:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RC Prime API Per Hit:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_rcprime_hit} onChange={(e) => this.setState({rate_limit_rcprime_hit:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">RC Prime API Per Second:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              RC Prime API Per Second:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_rcprime_duration} onChange={(e) => this.setState({rate_limit_rcprime_duration:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">Default API Per Hit:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Default API Per Hit:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_default_hit} onChange={(e) => this.setState({rate_limit_default_hit:e.target.value})} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-title">Default API Per Second:</label>
                          <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Default API Per Second:
                              </div>
                            </div>
                          <input type="number" name="token_expire_days" className="form-control" value={this.state.rate_limit_default_duration} onChange={(e) => this.setState({rate_limit_default_duration:e.target.value})} />
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">Authentication Token</h4>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="form-group">
                            <label className="control-title">Zeta Auth Token</label>
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                Zeta Auth Token
                                </div>
                              </div>
                            <input type="string" name="zeta_auth_token" className="form-control" value={this.state.zeta_auth_token} onChange={(e) => this.setState({zeta_auth_token:e.target.value})} />
                        </div>
                      </div>
                    </div>

                    <h4 className="subhading">DB Optimization Query Settings</h4>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Start Date</label>
                          <input type="date" name="dbOptimizStartDate" className="form-control" value={moment(this.state.dbOptimizStartDate).format('YYYY-MM-DD')} onChange={(e)=>{this.setState({dbOptimizStartDate: e.target.value})}} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">End Date (Exclusive)</label>
                          <input type="date" name="dbOptimizEndDate" className="form-control" value={moment(this.state.dbOptimizEndDate).format('YYYY-MM-DD')} onChange={(e)=>{this.setState({dbOptimizEndDate: e.target.value})}} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">API Type</label>
                          <Select2 multiple data={[
                            {id:2, text:'Challan'},
                            {id:9, text:'RCPrime'},
                            {id:10, text:'RCExcel'},
                            {id:14, text:'UsedCarPricing'},
                            {id:19, text:'UsedCarPricingV2'},
                            {id:15, text:'RCPrimeReverse'},
                            {id:32, text:'comboPrime'},
                            {id:33, text:'comboChallan'}
                          ]} value={this.state.dbOptimizApiType} className="form-control defaultOrder" options={{placeholder: 'search api type', tags: false } } onChange={(e)=>{
                            const selected=[];
                            let selectedOption=(e.target.selectedOptions);
                            for (let i = 0; i < selectedOption.length; i++){
                              selected.push(Number(selectedOption.item(i).value))
                            }
                            this.setState({dbOptimizApiType: selected});
                          }} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Source</label>
                          <Select2 multiple data={['gamma','delta', 'deltav2', 'surepass', 'deltaPro', 'deltaCache', 'zeta', 'theta', 'database','database_temp','usedCarSource','usedCarSourceV2','failure', 'timeout']} value={this.state.dbOptimizSelectedSource} className="form-control defaultOrder" options={{placeholder: 'search source', tags: false } } onChange={(e)=>{
                            const selected=[];
                            let selectedOption=(e.target.selectedOptions);
                            for (let i = 0; i < selectedOption.length; i++){
                              selected.push(selectedOption.item(i).value)
                            }
                            this.setState({dbOptimizSelectedSource: selected});
                          }} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Reason</label>
                          <Select2 multiple data={['complete', 'incomplete','failure', 'timeout', 'Challan Not Found','Database Not Found']} value={this.state.dbOptimizSelectedReason} className="form-control defaultOrder" options={{placeholder: 'search source', tags: false } } onChange={(e)=>{
                            const selected=[];
                            let selectedOption=(e.target.selectedOptions);
                            for (let i = 0; i < selectedOption.length; i++){
                              selected.push(selectedOption.item(i).value)
                            }
                            this.setState({dbOptimizSelectedReason: selected});
                          }} />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12" align="center">
                        <input type="submit" className="blueBtn" value="Update" onClick={this.update_data_into_DB} />
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>

          <div className="customPopup" id="infoPopUp1">
            <div className="bgLayer"></div>
            <div className="popUpBox">
              <div className="popScroll">
                <div className="infoMessagePopUp">
                  <div className="textB">Do you really want to update Setting?
                  </div>
                  <div className="submitRow">
                    <button className="backBtn" type="button" onClick={(e) => this.cancel(e)} >Cancel</button>
                    <button className="blueBtn okBtn" onClick={(e) => this.updateCommonSetting(e)} type="button">OK</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default SettingEdit;
